<template>
	<div>
		<div class="event-data" v-if="item">
			<div
				class="image"
				v-if="item && item.image && showImage"
				:style="`background-image:url(${item.image.url})`"
			></div>
			<div>
				<div class="">
					<h2>{{ item.name }}</h2>
				</div>
				<div class="data-set mt-3">
					<i class="icon icon-calendar"></i>
					<div class="info">
						<h2>{{ item.startAt | moment("ddd DD [de] MMMM, YYYY") }}</h2>
						<p>
							{{ item.startAt | moment("HH:mm") }} -
							{{ item.endAt | moment("HH:mm") }}
						</p>
					</div>
				</div>

				<div class="data-set">
					<i class="icon icon-map-marker"></i>
					<div class="info">
						<h2>{{ item.location.name }}</h2>
						<p>
							{{ item.location.address }},
							<span>{{ item.location.locality.name }}, </span>
							<span>{{ item.location.locality.region.name }}</span>
						</p>
					</div>
				</div>
				<div class="data-set" v-if="item.minAge">
					<i class="icon icon-ios-help-outline"></i>
					<div class="info">
						<h2>{{ item.minAge }}+</h2>
						<p></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "EventData",
	props: {
		eventId: {
			type: String,
			required: true
		},
		showImage: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			loading: false,
			item: null
		}
	},

	async beforeMount() {
		await this.load(this.eventId)
	},

	methods: {
		load(id) {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								code
								account {
									id
								}
								name
								startAt
								endAt
								description
								minAge
								image {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										id
										name
										region {
											id
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}

								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id
					}
				})
				.then(({ data }) => {
					this.loading = false
					this.item = data.event
					return true
				})
		}
	}
}
</script>

<style scoped lang="scss">
.event-data {
	width: 100%;
	padding: 16px;
	// margin-left: 12px;
	display: flex;
	flex-direction: row;
	align-items: center;

	.image {
		width: 228px;
		height: 228px;

		border-radius: 8px;
		margin-right: 12px;
		// margin: -8px 0px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	h2 {
		font-size: 1.5rem;
		color: #000;
		font-weight: 500;
	}
	.data-set {
		display: flex;
		align-items: center;
		justify-self: start;
		padding: 8px;
		border-radius: 8px;
		cursor: pointer;

		.icon {
			width: 18px;
			flex-shrink: 0;
			font-size: 1.3rem;
			color: #bbb;
			margin-right: 18px;
		}
		.info {
			flex-grow: 1;

			h2 {
				font-size: 1.1em;
			}
			p {
				font-size: 0.95em;
				color: #666;
				margin: 0px;
			}
		}
	}
}
</style>
